import { DepositDataImportComponent } from '@components/import/deposit-data/deposit-data-import.component';
import { NotificationComponent } from '@components/notification/notification.component';
import { SigninOidcComponent } from '@core/auth/signin-oidc/signin-oidc.component';
import { SilentRenewRedirectComponent } from '@core/auth/silent-renew-redirect/silent-renew-redirect.component';
import { Error401Component } from '@core/error-pages/error401/error401.component';
import { TimeoutComponent } from '@core/error-pages/timeout/timeout.component';
import { UnableToLoadPageComponent } from '@core/error-pages/unable-to-load-page/unable-to-load-page.component';
import { AuthGuardService } from '@services/guards/auth-guard.service';

// Note: paths must match with paths on options.ts

export const routes: any[] = [
  // { path: '', component: HomeComponent, canActivate: [AuthGuardService] },

  // OpenID Connect
  { path: 'signin-oidc', component: SigninOidcComponent },
  { path: 'redirect-silentrenew', component: SilentRenewRedirectComponent },

  // Error pages
  { path: 'error/timeout', component: TimeoutComponent },
  { path: 'error/401', component: Error401Component },
  { path: 'error', component: UnableToLoadPageComponent },

  // ALL
  { path: 'analysis-all', redirectTo: '/' },
  {
    path: 'notification',
    component: NotificationComponent
  },
  {
    path: 'backtest',
    loadChildren: () => import('../components/backtest-report/backtest-report.module').then(m => m.BacktestReportModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'concentration',
    loadChildren: () => import('../components/concentration-report/concentration-report.module').then(m => m.ConcentrationReportModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'current-period',
    loadChildren: () =>
      import('../components/current-position-summary-report/current-position-summary-report.module').then(
        m => m.CurrentPositionSummaryReportModule
      ),
    canActivate: [AuthGuardService]
  },
  {
    path: 'recalculation-queue',
    loadChildren: () => import('../components/recalculation/recalculation.module').then(m => m.RecalculationModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'export-preview',
    loadChildren: () => import('../components/export/export.module').then(m => m.ExportModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'export-alm',
    loadChildren: () => import('../components/export-alm/export-alm.module').then(m => m.ExportALMModule),
    canActivate: [AuthGuardService]
  },

  // PRODUCT
  { path: 'analysis', redirectTo: '/' },
  {
    path: 'dashboard',
    loadChildren: () => import('../components/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'product-detail',
    loadChildren: () => import('../components/product-detail/product-detail.module').then(m => m.ProductDetailModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'decay',
    loadChildren: () => import('../components/decay/decay.module').then(m => m.DecayModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'beta',
    loadChildren: () => import('../components/beta/beta.module').then(m => m.BetaModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'stable-balance',
    loadChildren: () => import('../components/stable-balance/stable-balance.module').then(m => m.StableBalanceModule),
    canActivate: [AuthGuardService]
  },

  // SETTINGS
  {
    path: 'settings',
    loadChildren: () => import('../components/settings/settings-routing.module').then(m => m.SettingsRoutingModule),
    canActivate: [AuthGuardService]
  },
  // Import
  {
    path: 'import',
    loadChildren: () => import('../components/import/import-routing.module').then(m => m.ImportRoutingModule),
    canActivate: [AuthGuardService]
  },

  {
    path: 'deposit-data',
    component: DepositDataImportComponent,
    outlet: 'import-outlet'
    // canDeactivate: [CanImportDeactivateGuard]
  },
  {
    path: 'market-rate-data',
    component: DepositDataImportComponent,
    outlet: 'import-outlet'
  },

  // GENERAL Routes
  { path: 'index', redirectTo: 'backtest', canActivate: [AuthGuardService] },
  { path: 'home', redirectTo: 'backtest', canActivate: [AuthGuardService] },
  { path: '**', redirectTo: 'backtest', canActivate: [AuthGuardService] }

  // { path: '/', redirectTo: 'backtest' }
];
